import React, { useState } from "react";
import { agentLogin } from "../lib/api";
import lionLogo from "../assets/images/lion-logo.png";
import logo from "../assets/images/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons/faEyeSlash";

const Login = () => {

  const [hide,setHide] = useState(false)

  const [form, setForm] = useState({
    login_id: "",
    password: "",
  });


  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const data = await agentLogin(form);

      // support either {token} or {success, token}
      const token = data?.token || (data?.success ? data?.token : null);

      if (token) {
        setMessage(" Login successful!");

        // Store token in localStorage
        localStorage.setItem("token", token);

        // Redirect to home
         window.location.href = "/";
      } else {
        setMessage(" " + (data?.message || "Login failed"));
      }
    } catch (error) {
      console.error(error);
      setMessage(error?.response?.data?.error || " Server error. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center p-5 login">
      <div className="flex flex-col items-center bg-white rounded-lg shadow-md p-5 w-full max-w-sm">
        <img src={lionLogo} className="w-14 mb-4" alt="Lion-Logo" />
        <h3 className="text-xl font-bold text-gray-700 mb-8 uppercase">Log masuk</h3>
        <img src={logo} className="w-48 mb-4" alt="Logo" />
        <h3 className="text-xl font-bold text-gray-700 mb-8 uppercase">Hasil</h3>
        <form onSubmit={handleSubmit} className="w-full">
          <div className="flex  items-center w-full border-2 rounded-lg  mb-3">
          <input
            type="text"
            name="login_id"
            value={form.login_id}
            onChange={handleChange}
            className="py-2 px-3 outline-none  w-full m-1"
            placeholder="Login ID"
            required
          />
          </div>
          <div className="flex  items-center w-full border-2 rounded-lg  mb-8">
          <input
            type={hide?"text":"password"}
            name="password"
            value={form.password}
            onChange={handleChange}
            className="py-2 px-3 m-1  w-full outline-none"
            placeholder="Password"
            required
          />
          <FontAwesomeIcon icon={hide?faEye:faEyeSlash} className="mx-2 text-gray-600" onClick={()=>setHide(!hide)}/>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="py-2 px-3 rounded-lg text-white bg-indigo-500 font-semibold w-full hover:bg-indigo-600 disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        {message && <p className="mt-4 text-sm text-gray-600">{message}</p>}
      </div>
    </div>
  );
};

export default Login;
